module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-datenschutz-circle-82be1ca3c6d8be27bb899c582473b38e.svg";